import {
  Button,
  UncontrolledAlert,
  Col,
  Row,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { AvForm, AvField } from "availity-reactstrap-validation";
import ClientDropDown from "components/Common/Filters/ClientDropDown";
import FromToDate from "components/Common/Filters/FromToDate";

const MasterFilter = (props) => {
  const { t } = useTranslation();
  // get query paramerters from url
  const search = useLocation().search;
  const query = new URLSearchParams(search);

  const [openCanvas, setOpenCanvas] = useState(false);

  const initValues = {
    customerId: "",
    filterDate: {
      fromDate: "",
      toDate: "",
    },
    status: query.get("status") || "",
    requestId: "",
  };

  const { filteredValues = initValues } = props;
  const [values, setValues] = useState(filteredValues);

  const [filtered, setFilter] = useState(false);
  useEffect(() => {
    let f = JSON.stringify(initValues) === JSON.stringify(values);
    setFilter(!f);
  }, [values]);

  const statusOptions = ["APPROVED", "PENDING", "REJECTED"];

  const clientChangeHandler = (obj) => {
    setValues({
      ...values,
      customerId: obj.value,
    });
  };

  const resetFilter = () => {
    setValues(initValues);
    props.filterChangeHandler(initValues);
    // setOpenCanvas(false);
  };

  const dateChangeHandler = (filterDate) => {
    setValues({
      ...values,
      filterDate: filterDate,
    });
  };

  const toggleCanvas = () => {
    setOpenCanvas(!openCanvas);
  };

  useEffect(() => {
    if (!props.showAddSuccessMessage && openCanvas) {
      setOpenCanvas(false);
    }
  }, [props.showAddSuccessMessage]);

  return (
    <React.Fragment>
      <Button
        color="primary"
        className={"btn btn-primary"}
        onClick={toggleCanvas}
      >
        <i className="bx bx-filter me-1" />
        {filtered ? t("Update Filter") : t("Advance Filter")}
      </Button>
      <Offcanvas
        isOpen={openCanvas}
        direction="end"
        scrollable
        toggle={toggleCanvas}
      >
        <OffcanvasHeader toggle={toggleCanvas} tag="h4">
          {t("Advance Filter")}
        </OffcanvasHeader>
        <OffcanvasBody>
          <AvForm
            className="p-4"
            onValidSubmit={() => {
              props.filterChangeHandler(values);
              setOpenCanvas(false);
            }}
          >
            <Row>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="status"
                    label={t("Status")}
                    value={props.filteredValues?.status || values.status}
                    onChange={(e) => {
                      setValues({
                        ...values,
                        status: e.target["value"],
                      });
                    }}
                  >
                    <option key={""} value={""}>
                      {t("All")}
                    </option>
                    {statusOptions.map((item) => {
                      return (
                        <option key={item} value={item}>
                          {t(item)}
                        </option>
                      );
                    })}
                  </AvField>
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="requestId"
                    label={t("Request Id")}
                    placeholder={t("Request Id")}
                    type="text"
                    value={props.filteredValues?.requestId || values.requestId}
                    onChange={(e) => {
                      setValues({
                        ...values,
                        requestId: e.target["value"],
                      });
                    }}
                  />
                </div>
              </Col>
            </Row>
            <div className="mb-3">
              <FromToDate
                filterDate={values.filterDate}
                dateChangeHandler={dateChangeHandler}
              />
            </div>
            <div className="mb-3">
              <ClientDropDown
                defaultValue={
                  props.filteredValues?.customerId || values.selectCountry
                }
                clientChangeHandler={clientChangeHandler}
              />
            </div>

            <div className="row">
              <div className="col-sm-12 text-center">
                <Button
                  disabled={!filtered}
                  type="submit"
                  color="primary"
                  className="btn btn-primary btn-md center-block"
                >
                  {t("Filter")}
                </Button>{" "}
                <Button
                  onClick={resetFilter}
                  color="primary"
                  type="reset"
                  className="btn btn-danger btn-md center-block"
                >
                  {t("Reset")}
                </Button>
              </div>
            </div>
          </AvForm>
          {props.error && (
            <UncontrolledAlert color="danger">
              <i className="mdi mdi-block-helper me-2"></i>
              {t(props.error)}
            </UncontrolledAlert>
          )}
        </OffcanvasBody>
      </Offcanvas>
    </React.Fragment>
  );
};

export default MasterFilter;
